<template>
  <div class="input-container" :class="{ 'required-fail': requiredFail }">
    <input
      class="no-border"
      :value="value"
      @input="updateValue($event.target.value)"
      @keypress="checkInput"
      type="number"
      :disabled="disabled"
      :placeholder="placeholder"
      :min="min"
      :max="max"
      :step="step ? step : autoNumberFieldStep"
      :id="fieldId"
    />
  </div>
</template>

<script>
import { inputTypeMixin } from "@/mixins/forms/dynamicObjectForms/inputTypeMixin";

export default {
  name: "InputTypeNumber",

  mixins: [inputTypeMixin],

  props: {
    step: {
      type: Number | String
    },

    min: {
      type: Number | String
    },

    max: {
      type: Number | String
    },

    inputType: {
      type: String
    }
  },

  computed: {
    autoNumberFieldStep() {
      if (this.inputType === "float" || this.inputType === 'float_pos' || this.inputType === 'number_pos') {
        return 0.00001;
      }
      return 1;
    }
  },

  methods: {
    isFloat(n) {
      if (this.inputType === "float") {
        return true;
      } else if (this.inputType === "int") {
        return false;
      } else {
        return Number(n) === n && n % 1 !== 0;
      }
    },
    checkInput(e) {
      switch (this.inputType) {
        case "int_pos":
          this.checkIntegerPositive(e);
          break;
        case "int":
          this.checkIfMinusIsValid(e);
          this.checkInteger(e);
          break;
        case "number":
        case "float":
          this.checkIfMinusIsValid(e);
          this.checkFloat(e);
          break;
        case "number_pos":
        case "float_pos": 
          this.checkFloatPositive(e);
          break;
        default:
          break;
      }
    },
    //only allow positive numbers
    checkFloat(e) {
      const regex = /^-?[\.,0-9]*$/;
      //if input is not a number a comma or a dot, validates to true
      if(!regex.test(e.key)){
        e.preventDefault();
      }
    },
     checkFloatPositive(e) {
      const regex = /^[\.,0-9]*$/;
      //if input is not a number a comma or a dot, validates to true
      if(!regex.test(e.key)){
        e.preventDefault();
      }
    },
    //only allow positive integers
    checkIntegerPositive(e) {
      const regex = /^[0-9]*$/;
      //if input is not a number validates to true
      if(!regex.test(e.key)){
        e.preventDefault();
      }
    },
    checkInteger(e) {
      const regex = /^-?[0-9]*$/;
      //if input is not a number validates to true
      if(!regex.test(e.key)){
        e.preventDefault();
      }
    },
    checkIfMinusIsValid(e){
    let value = String(this.value);
    let newkey= String(e.key);
    if(newkey.includes('-')){
        if(value.length !=0){
          e.preventDefault();
        }
        if(value.includes("-")){
        e.preventDefault();
      }
      }
    }
  }
};
</script>
<style>
  .no-border{
    border-bottom: none !important;
  }
  .no-border:focus{
    border-bottom: 1px solid #4fa2b7 !important;
  }
</style>



// WEBPACK FOOTER //
// src/components/Home/Forms/_Atoms/InputTypes/InputTypeNumber.vue